import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Eager load all controllers defined in the controllers directory
import MobileMenuController from "./mobile_menu_controller"
import FormController from "./form_controller"
import FlashController from "./flash_controller"
import PromoVideoController from "./promo_video_controller"

application.register("mobile-menu", MobileMenuController)
application.register("form", FormController)
application.register("flash", FlashController)
application.register("promo-video", PromoVideoController)

export { application }
